import { render, staticRenderFns } from "./RegisterPlan.vue?vue&type=template&id=1f537cd9&scoped=true"
import script from "./RegisterPlan.vue?vue&type=script&lang=js"
export * from "./RegisterPlan.vue?vue&type=script&lang=js"
import style0 from "./RegisterPlan.vue?vue&type=style&index=0&id=1f537cd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f537cd9",
  null
  
)

export default component.exports